export default __webpack_public_path__ + "static/media/040_tunnel.last.3cb87431.avif";